export { MobileSupportingContent } from './MobileSupportingContent';
